import React from 'react'
import { api } from 'utils'
import { PAGINEDETAIL } from 'utils/endpoint'
import MetaSeo from 'components/atomic/MetaSeo'
import CheckoutErrorTemplate from 'react-components/templates/CheckoutErrorTemplate/CheckoutErrorTemplate'

function CheckoutError({ pagina }) {
  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <CheckoutErrorTemplate />
    </>
  )
}

export const getServerSideProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'checkout-error',
    },
  })
  const pagina = await pageResponse.data
  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps } }
}

CheckoutError.loginRequired = true
CheckoutError.headerVariant = 'checkout'
CheckoutError.footerVariant = 'none'

export default CheckoutError
